import { Outlet, useNavigate } from "react-router-dom";
import AuthenticatedScreenDefinition from "@/layouts/AuthenticatedScreenDefinition";
import ensureAuthenticated from "@/contexts/ensureAuthenticated";
import { useEffect } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/utils/react-query";

export default function OverallEntrypoint() {
  const { authenticated } = ensureAuthenticated();

  
  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticated) {
      navigate("/login");
    }
  }, [authenticated, navigate]);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthenticatedScreenDefinition>
          <Outlet />
      </AuthenticatedScreenDefinition>
    </QueryClientProvider>
  );
}
